import { v4 } from 'uuid';

export default () => v4();
export const guid = () => v4();
